import React from 'react';
import { Modal } from 'react-bootstrap';
import { formatAmount } from '../../../utils/formatAmount';
import { getValueProperty } from '../../../utils/refund';

function CreditRefundedModal({
    show,
    handleClose,
    totalCreditRefunded,
    modalTitle = "Total Credits Refunded",
    columnTitle = "No. of Credits Issued",
    user = false
}) {


    return (
        <Modal show={show} onHide={handleClose} className="creditmodal" centered>
            <Modal.Header closeButton>
                <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="modaltable">
                    <table>
                        <thead>
                            <tr>
                                <th>Project</th>
                                <th className="text-center">{columnTitle}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {totalCreditRefunded && totalCreditRefunded.length > 0 ? (
                                totalCreditRefunded.map((item, index) => {
                                    const propertyName = getValueProperty(item);
                                    const value = propertyName ? item[propertyName] : 0;

                                    return (
                                        <tr key={item._id || index}>
                                            <td>
                                                <div className="maintoken">
                                                    <div className="tokenimg">
                                                        <img
                                                            src={`/assets/${item._id.toLowerCase()}.svg`}
                                                            alt="innerimg"
                                                            className="innerimg"
                                                        />
                                                    </div>
                                                    <p className="tokenpara">{item._id}</p>
                                                </div>
                                            </td>
                                            <td className="text-center">{formatAmount(value, user)}</td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="2" className="text-center">No data available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <button onClick={handleClose} className="closebtn">Close</button>
            </Modal.Body>
        </Modal>
    );
}

export default CreditRefundedModal;

// import React from 'react';
// import { Modal } from 'react-bootstrap';

// function CreditRefundedModal({ show, handleClose, totalCreditRefunded, modalTitle = "Total Credits Refunded", columnTitle = "No. of Credits Issued" }) {
//     // Format the amount for display
//     // const formatAmount = (amount) => {
//     //     if (!amount && amount !== 0) return '$0';

//     //     if (amount >= 1000000) {
//     //         return `$${(amount / 1000000).toFixed()}M`;
//     //     }
//     //     return `$${(amount / 1000).toFixed(4)}K`;
//     // };
//     const formatAmount = (amount) => {
//         if (!amount && amount !== 0) return '$0';

//         if (amount >= 1000000) {
//             return `$${(amount)}`;
//         }
//         return `$${amount}`;
//     };
//     return (
//         <Modal show={show} onHide={handleClose} className="creditmodal" centered>
//             <Modal.Header closeButton>
//                 <Modal.Title>{modalTitle}</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <div className="modaltable">
//                     <table>
//                         <thead>
//                             <tr>
//                                 <th>Project</th>
//                                 <th className="text-center">{columnTitle}</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {totalCreditRefunded && totalCreditRefunded.length > 0 ? (
//                                 totalCreditRefunded.map((item, index) => (
//                                     <tr key={item._id || index}>
//                                         <td>
//                                             <div className="maintoken">
//                                                 <div className="tokenimg">
//                                                     <img
//                                                         src={`/assets/${item._id.toLowerCase() }.svg`}
//                                                         alt="innerimg"
//                                                         className="innerimg"
//                                                     />
//                                                 </div>
//                                                 <p className="tokenpara">{item._id}</p>
//                                             </div>
//                                         </td>
//                                         <td className="text-center">{formatAmount(item.creditRefunded)}</td>
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td colSpan="2" className="text-center">No data available</td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//                 <button onClick={handleClose} className="closebtn">Close</button>
//             </Modal.Body>
//         </Modal>
//     );
// }

// export default CreditRefundedModal;